// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_2rwubseHOY36k740g7Od9D","settingsTitle":"hmjX3-cIe1hUujPF5-4FF","settingsDescription":"oPoKSftwRw988nTFEN5sP","selector":"_17OvxNIP3L1AKljFXTrgBD"};